import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import LoyaltyCardsFilter from './filterEntity';
import FilterModel from './filterModel';

import { TableApiInterface } from '@/types/page/table';
export const MODULE_NAME = 'loyalty_cards';

const filterModel = new FilterModel();
const filter = getModule(LoyaltyCardsFilter);

filter.setFilterName('loyaltyCardsFilter');
filter.setTemplateClassName('template-lg');
filter.setFilterModel(filterModel.filterModel);
filter.setFilterHandlers(filterModel.filterHandlers);

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class LoyaltyCardsModule extends PageBaseModule {
    filter = filter;

    constructor(module: LoyaltyCardsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle('Бонусные карты');
        page.values.actionPagination = 'consultations/updatePage';
        page.values.actionPageAmountItems = 'consultations/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        
        this.pageSettings = page.values;
        this.pageSettings.routeName = 'loyalty_card';
        this.pageSettings.routeParam = `id`;
    }

    @Action({ rawError: true })
    async setPatientId(patientId: string) {
        filter.SET_SEARCH({ key: 'patientId', value: patientId });
        filter.updateFilter();
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                MODULE_NAME,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            const table = await this.prepareList(result.table);
            await this.context.dispatch('setList', table);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    prepareList(table: TableApiInterface): TableApiInterface {
        table.rows = table.rows.map(row => {
            if (row.number) {
                row.number = `<a href="${window.location.origin}/patients/${row.patientId}/loyalty-cards/${row.id}" class="cp-table__item-link">${row.number}</a>`;
            }

            return row;
        });

        return table;
    }
}

export default getModule(LoyaltyCardsModule);